import { render, staticRenderFns } from "./ptPercent.vue?vue&type=template&id=1b22b0e3"
import script from "./ptPercent.vue?vue&type=script&lang=js"
export * from "./ptPercent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports